import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';

import defaultStyles from './selection-items.scss';

import SelectionItem from './selection-item/selection-item';
import query, { SelectionItemsQuery } from './selection-items.graphql';

export interface Props {
    styles: typeof defaultStyles;
    initial?: Set<string>;
    onChange: (values: Set<string>) => void;
}

interface State {
    selectionItemValues: Set<string>;
}

class SelectionItems extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        let selectionItemValues = new Set<string>();
        if (props.initial) {
            selectionItemValues = props.initial;
        }
        this.state = { selectionItemValues };
    }
    componentDidUpdate(prevProps: Props) {
        if (this.props.initial && prevProps.initial !== this.props.initial) {
            this.setState({ selectionItemValues: this.props.initial });
        }
    }

    onChange = (id: string) => () => {
        this.setState(({ selectionItemValues }) => {
            const newSelectionItemValues = new Set(selectionItemValues);
            if (newSelectionItemValues.has(id)) {
                newSelectionItemValues.delete(id);
            } else {
                newSelectionItemValues.add(id);
            }
            this.props.onChange(newSelectionItemValues);
            return { selectionItemValues: newSelectionItemValues };
        });
    };

    render() {
        const { styles } = this.props;

        return (
            <Query<SelectionItemsQuery> query={query} notifyOnNetworkStatusChange={true} fetchPolicy='cache-first'>
                {({ data, loading, refetch }) => {
                    if (data && data.selectionItems) {
                        return (
                            <div className={styles.chipsWrapper}>
                                {data.selectionItems.edges.map(edge => {
                                    if (edge && edge.node) {
                                        return (
                                            <SelectionItem
                                                key={edge.node.id}
                                                onClick={this.onChange(edge.node.id)}
                                                selected={this.state.selectionItemValues.has(edge.node.id)}
                                            >
                                                {edge.node.name}
                                            </SelectionItem>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        );
                    }
                    return null;
                }}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(SelectionItems);
